// Portuguese (Brazil) (`pt-BR`) shell baseline
import { layoutPtBR } from './pt-BR/layout'
import { homePtBR } from './pt-BR/home'
import { playPtBR } from './pt-BR/play'
import { demoPtBR } from './pt-BR/demo'
import { booksPtBR } from './pt-BR/books'
import { commercePtBR } from './pt-BR/commerce'
import { communityPtBR } from './pt-BR/community'
import { dashboardPtBR } from './pt-BR/dashboard'
import { authPtBR } from './pt-BR/auth'
import { marketingPtBR } from './pt-BR/marketing'
import { worldPtBR } from './pt-BR/world'
import { encyclopediaPtBR } from './pt-BR/encyclopedia'
import { systemPtBR } from './pt-BR/system'
import { cityPtBR } from './pt-BR/city'
import type { MessageCatalog } from '@gamecodex/world-config'

export const basePtBR: MessageCatalog = {
  ...layoutPtBR,
  ...homePtBR,
  ...playPtBR,
  ...demoPtBR,
  ...booksPtBR,
  ...commercePtBR,
  ...communityPtBR,
  ...dashboardPtBR,
  ...authPtBR,
  ...marketingPtBR,
  ...worldPtBR,
  ...encyclopediaPtBR,
  ...systemPtBR,
  ...cityPtBR,
}
